import {
  CarRental,
  DirectionsBus,
  ElectricScooter,
  LocalTaxi,
} from '@mui/icons-material'

export enum CompanyAddressType {
  Primary = 'Primary',
  CorrespondenceAddress = 'CorrespondenceAddress',
}

export enum ChargeExceptionType {
  BankHolidays = 'BankHolidays',
  Custom = 'Custom',
}

export enum CustomExceptionType {
  Always = 'Always',
  Date = 'Date only',
  DateTime = 'Date and Time',
  Day = 'Specific Day',
  Time = 'Time only',
  Weekday = 'Weekday',
  Weekend = 'Weekend',
}

export enum CompanyStatusType {
  Onboarding = 'Onboarding',
  Active = 'Active',
  Suspended = 'Suspended',
  Inactive = 'Inactive',
}

export enum SupplierRegionType {
  Scotland = 'Scotland',
  NorthernIreland = 'Northern Ireland',
  Wales = 'Wales',
  NorthEast = 'North East',
  NorthWest = 'North West',
  YorkshireAndTheHumber = 'Yorkshire and the Humber',
  WestMidlands = 'West Midlands',
  EastMidlands = 'East Midlands',
  SouthWest = 'South West',
  SouthEast = 'South East',
  EastOfEngland = 'East of England',
  GreaterLondon = 'Greater London',
}

export enum BillingTerm {
  DaysFromInvoice = 'Days from invoice',
  EndOfMonth = 'End of month',
}

export enum Days {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum BookingType {
  Taxi = 'Taxi',
  Coach = 'Coach',
  CarRental = 'Car rental',
  MicroMobility = 'Micro mobility',
}

export const BookingTypeIcons = {
  Taxi: LocalTaxi,
  Coach: DirectionsBus,
  CarRental: CarRental,
  MicroMobility: ElectricScooter,
}

export enum JourneyType {
  OneWay = 'OneWay',
  Return = 'Return',
  Flexible = 'Flexible',
  WaitAndReturn = 'WaitAndReturn',
  AsDirected = 'AsDirected',
}

export enum JourneyTypeLabels {
  OneWay = 'One Way',
  Return = 'Return',
  Flexible = 'Flexible',
  WaitAndReturn = 'Wait And Return',
  AsDirected = 'As Directed / Hourly',
}

export enum ClientType {
  Corporate = 'Corporate',
  TMC = 'TMC',
  Rail = 'Rail',
}

export enum ReferenceType {
  FreeFormat = 'FreeFormat',
  Array = 'Array',
}

export enum TravelService {
  MeetAndGreet = 'MeetAndGreet',
}

export enum DispatchSystem {
  magenta = 'Magenta',
  icabbi = 'iCabbi',
  autocab = 'AutoCab',
  direct = 'Direct Supplier',
}

export enum FeeType {
  Fixed = 'Fixed',
  Percentage = 'Percentage',
}

export enum CurrencyValue {
  GBP = 'GBP',
  USD = 'United States Dollars',
  EUR = 'Euro',
  SAR = 'Saudi Arabian Riyals',
}

export enum CurrencyCode {
  GBP = 'GBP',
  EUR = 'EUR',
  USD = 'USD',
  CHF = 'CHF',
  SAR = 'SAR',
  CNY = 'CNY',
  JPY = 'JPY',
  SGD = 'SGD',
}

export const CurrencySymbols: Record<CurrencyCode, string> = {
  [CurrencyCode.GBP]: '£',
  [CurrencyCode.EUR]: '€',
  [CurrencyCode.USD]: '$',
  [CurrencyCode.CHF]: 'Fr.',
  [CurrencyCode.SAR]: '﷼',
  [CurrencyCode.CNY]: '¥',
  [CurrencyCode.JPY]: '¥',
  [CurrencyCode.SGD]: 'S$',
}

export enum WaitingPeriod {
  free = 'Free period',
  grace = 'Grace period',
}
export enum YesNo {
  yes = 'Yes',
  no = 'No',
}

export enum TaxiVehicleType {
  Taxi_Standard = 'Standard',
  Taxi_Executive = 'Executive',
  Taxi_Premium = 'Premium',
  Taxi_MPV = 'MPV',
  Taxi_MPV_Plus = 'MPV+',
  Taxi_MPV_Premium = 'MPV Premium',
  Taxi_SUV = 'SUV',
  Taxi_SUV_Executive = 'SUV Executive',
  Taxi_Hybrid = 'Hybrid',
  Taxi_Zero_Standard = 'Zero',
  Taxi_Zero_Executive = 'Zero Executive',
  Taxi_Accessible = 'Accessible',
  Taxi_BlackCab = 'Black Cab',
  Taxi_Estate = 'Estate',
  Taxi_Minibus_9 = 'Minibus 9 Seater',
  Taxi_Minibus_12 = 'Minibus 12 Seater',
  Taxi_Minibus_16 = 'Minibus 16 Seater',
  Taxi_Any = 'Any',
  Chauffer_Executive = 'Chauffer: Executive',
  Chauffer_Premium = 'Chauffer: Premium',
  Chauffer_MPV = 'Chauffer: MPV',
  Chauffer_Zero_Executive = 'Chauffer: Zero Executive',
  Chauffer_Zero_Premium = 'Chauffer: Zero Premium',
  Ridehail_Standard = 'Ridehail: Standard',
  Ridehail_MPV = 'Ridehail: MPV',
  Ridehail_Zero = 'Ridehail: Zero',
  Ridehail_Executive = 'Ridehail: Executive',
  Ridehail_Premium = 'Ridehail: Premium',
  Ridehail_Accessible = 'Ridehail: Accessible',
  Ridehail_MPV_Plus = 'Ridehail: MPV+',
  Ridehail_Priority = 'Ridehail: Priority',
  Metered_BlackCab = 'Metered: Black Cab',
  Metered_Zero_BlackCab = 'Metered: Zero Black Cab',
  Metered_YellowCab = 'Metered: Yellow Cab',
  Coach_Standard = 'Coach: Standard',
  Coach_Executive = 'Coach: Executive',
  Coach_LuxuryVIP = 'Coach: Luxury VIP',
}

export enum CongestionZoneVAT {
  Standard = 'Standard',
  Reduced = 'Reduced',
  Zero = 'Zero',
  Exempt = 'Exempt',
}

export enum Theme {
  JYRNEY = 'Jyrney',
  EASTHOUSE = 'Easthouse',
  ADVANTAGE = 'Advantage Travel',
  RUNYOURFLEET = 'RunYourFleet',
  ONWRD = 'ONWRD',
  TAKEME = 'TAKEME',
  PENDRAGON = 'Pendragon',
  SCS = 'SCS',
  TAKETWO = 'TAKETWO',
  REEDANDMACKAY = 'Reed & Mackay',
  SUNWAYS = 'Sunways',
  TYSERS = 'Tysers',
  VEEZU = 'Veezu',
  BELZ = 'Belz',
  VEEZU_BBC = 'Veezu-BBC',
}

export enum vATTreatmentTypeName {
  Full = 'Full',
  ServiceCharge = 'Service Charge',
  None = 'None',
}

export enum bookingStatus {
  Quoted = 'Booked',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  InProgress = 'In Progress',
  In_Progress = 'In Progress',
  Complete = 'Complete',
}

export enum journeyUpdateStatus {
  Allocated = 'Allocated',
  Declined = 'Declined',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  OnRoute = 'On Route',
  Arrived = 'Arrived',
  Passenger_Picked_Up = 'Passenger Picked Up',
  Passenger_Dropped_Off = 'Passenger Dropped Off',
  OnRoute_Passenger_On_Board = 'On Route Passenger On Board',
  Completed = 'Completed',
  Supplier_Cancelled = 'Supplier Cancelled',
  No_Show = 'No Show',
  Driver_Location_Update = 'Driver Location Update',
  Driver_Allocated = 'Driver Allocated',
}

export enum journeyJobStatusSelector {
  Unallocated = 'Unallocated',
  Awaiting_Dispatch = 'Awaiting Dispatch',
  Not_Dispatched = 'Not Dispatched',
  Ontime = 'On time',
  Delayed = 'Delayed',
  Driver_Waiting = 'Driver Waiting',
  In_Progress = 'In Progress',
  Attention_Needed = 'Attention Needed',
}

export const MANUAL_INTERVENTION_STATUS_LABEL = 'Manual Intervention'

export enum CallStates {
  CONNECTING = 'Connecting',
  READY = 'Ready',
  INCOMING = 'Incoming',
  ON_CALL = 'On call',
  OFFLINE = 'Offline',
}

export enum CallerType {
  USER = 'User',
  PASSENGER = 'Passenger',
  SUPPLIER = 'Supplier',
  DRIVER = 'Driver',
}

export enum CurrencySymbol {
  EUR = '€', // Euro
  CRC = '₡', // Costa Rican Colón
  GBP = '£', // British Pound Sterling
  ILS = '₪', // Israeli New Sheqel
  INR = '₹', // Indian Rupee
  JPY = '¥', // Japanese Yen
  KRW = '₩', // South Korean Won
  NGN = '₦', // Nigerian Naira
  PHP = '₱', // Philippine Peso
  PLN = 'zł', // Polish Zloty
  PYG = '₲', // Paraguayan Guarani
  THB = '฿', // Thai Baht
  UAH = '₴', // Ukrainian Hryvnia
  VND = '₫', // Vietnamese Dong
  USD = '$', // US Dollar
  SAR = '﷼', // Saudi Arabian Riyals
}

export enum BookingSearchStatus {
  QUOTED = 'Quoted',
  CONFIRMED = 'Confirmed',
  CANCELLED = 'Cancelled',
  INPROGRESS = 'InProgress',
  COMPLETE = 'Complete',
}

export enum SystemRoles {
  jyrneyAdmin = 'Jyrney Admin',
  clientAdmin = 'Client Admin',
  traveller = 'Traveller',
  // clientSupport = 'Client Support',
  // supplierSupport = 'Supplier Support',
  // operationsSupport = 'Operations Support',
  // operationsSupportSupervisor = 'Operations Support Supervisor',
  // finance = 'Finance',
  // travelConsultant = 'Travel Consultant',
  // seniorTravelConsultant = 'Senior Travel Consultant',
  passenger = 'Passenger',
  // supplierAdmin = 'Supplier Admin',
  // dispatcher = 'Dispatcher',
  // operator = 'Operator',
  platformAdmin = 'Platform Admin',
}

export enum PermissionType {
  FullControl = 'Full Control',
  ViewOnly = 'View Only',
  BookOnly = 'Book Only',
}

export enum DefaultValueType {
  Specified = 'Specified',
  UserProperty = 'UserProperty',
}

export enum ChargeStatus {
  OnRoute = 'On Route',
  Arrived = 'Arrived',
  Passenger_Picked_Up = 'Passenger Picked Up',
  Passenger_Dropped_Off = 'Passenger Dropped Off',
  OnRoute_Passenger_On_Board = 'On Route - Passenger Onboard',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Driver_Location_Update = 'Driver Location - Update',
  Supplier_Cancelled = 'Supplier Cancelled',
  No_Show = 'No Show',
  Driver_Allocated = 'Driver Allocated',
  Completed_Pending_Invoice = 'Completed - Pending Invoice',
}
